import { type ReactNode } from 'react';
import { BODY, Bullet, PullQuote, Section } from './rules-typography';

export function InfiniteLoop(): ReactNode {
  return (
    <Section title="4. El loop infinito">
      <p className={BODY}>Cuando encuentres un buen perfil:</p>
      <ol className={`${BODY} space-y-1.5`}>
        <Bullet>Dale like al post que te inspiró.</Bullet>
        <Bullet>Guarda el post si es autor.</Bullet>
        <Bullet>Síguelo solo si ya está listado por ti o por alguien.</Bullet>
        <Bullet>Mira las cuentas sugeridas.</Bullet>
        <Bullet>Envía el link a @the3333games.</Bullet>
        <Bullet>Entra en otra cuenta.</Bullet>
        <Bullet>Repite.</Bullet>
      </ol>
      <PullQuote>
        Quien más repite, más encuentra. Más encuentra, más gana.
      </PullQuote>
    </Section>
  );
}

export function SendCreator(): ReactNode {
  return (
    <Section title="5. Enviar un creador al juego">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Encuentra la publicación que te hizo decir «match con Debook».
        </Bullet>
        <Bullet>
          Copia el link de{' '}
          <strong className="text-text-primary">la publicación</strong>, no del
          perfil.
        </Bullet>
        <Bullet>Envía el link al chat de @the3333games.</Bullet>
      </ul>
      <p className={BODY}>
        Importante: no respondemos por privado en @the3333games. Para ayuda,
        escribe a soporte por WhatsApp con Luz.
      </p>
    </Section>
  );
}

export function ProDms(): ReactNode {
  return (
    <Section title="DMs nivel pro">
      <p className={BODY}>Personaliza el chat con Instagram:</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Mantén pulsado 2 segundos en la pantalla.</Bullet>
        <Bullet>Cambia el estilo de fondo.</Bullet>
        <Bullet>Elige el tema rojo (BTS).</Bullet>
      </ul>
      <p className={BODY}>Rojo = foco, acción, dinero.</p>
    </Section>
  );
}
